import { i18nt } from '@/i18n';

type SocketCallbacks = {
  onOpenCallback?: (ws: WebSocket) => void;
  onMessageCallback?: (data: string, ws: WebSocket | null) => void;
  onError?: (err: unknown) => void;
  onCloseCallback?: () => void;
  onReconnectRequest?: () => void;
};

class SocketLink {
  socketUrl: string = '';
  pong: string = '';
  ping: string = '';
  interval: number = 10000;
  waittime: number = 5000;
  keepAlive: boolean = false;
  ws: WebSocket | null = null;
  callbacks: SocketCallbacks = {};
  private heartBeatTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    url: string,
    callbacks: SocketCallbacks,
    heartBeatOpts: {
      pong: string;
      ping: string;
      interval: number;
      waittime: number;
    },
  ) {
    this.callbacks = callbacks;
    this.socketUrl = url;
    this.pong = heartBeatOpts.pong;
    this.ping = heartBeatOpts.ping;
    this.interval = heartBeatOpts.interval;
    this.waittime = heartBeatOpts.waittime;
    this.keepAlive = false;
  }

  close() {
    this.keepAlive = false;
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.onerror = null;
      this.ws.onmessage = null;
      this.ws.onopen = null;
      this.ws.close();
      this.ws = null;
      this.clearHeartBeatTimer();
    }
  }

  // 是否强制用重连
  initSocket(force = false): WebSocket {
    if (!force && this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
      return this.ws;
    }
    if (this.ws) {
      const oldWs = this.ws;
      oldWs.onclose = null;     // 先 null 掉 handler
      oldWs.onerror = null;
      oldWs.onmessage = null;
      oldWs.onopen = null;
      oldWs.close();             // 再关旧连接
      // 不设 this.ws = null，因为马上就要赋值
    }

    this.ws = new WebSocket(this.socketUrl);
    this.ws.onmessage = this.socketOnmessage.bind(this);
    this.ws.onopen = this.socketOnOpen.bind(this);
    this.ws.onerror = this.socketOnError.bind(this);
    this.ws.onclose = this.socketOnClose.bind(this);
    return this.ws;
  }

  private clearHeartBeatTimer() {
    if (this.heartBeatTimer) {
      clearTimeout(this.heartBeatTimer);
    }
  }

  heartBeat() {
    if (!this.ws || this.ws.readyState !== WebSocket.OPEN) {
      this.callbacks.onReconnectRequest?.();
      return;
    }
    this.ws.send(this.ping);
    this.keepAlive = false; // 发送ping后，等待pong，如果超过waittime时间没有收到pong，则认为连接断开

    this.clearHeartBeatTimer();
    this.heartBeatTimer = setTimeout(() => {
      try {
        if (!this.keepAlive) {
          this.heartBeat();
        }
      } catch {
        this.callbacks.onReconnectRequest?.();
      }
    }, this.waittime);

  }

  socketOnmessage(res: MessageEvent) {
    if (this.callbacks.onMessageCallback) {
      this.callbacks.onMessageCallback(res.data, this.ws);
    }
    this.msgTimer = null;
    clearTimeout(this.msgTimer);
    if (res.data === this.pong) {
      this.keepAlive = true;
      this.msgTimer = setTimeout(() => this.heartBeat(), this.interval);
    }
  }

  socketOnOpen() {
    if (this.callbacks.onOpenCallback) {
      this.callbacks.onOpenCallback(this.ws!);
    }
  }

  socketOnError(err: Event) {
    this.callbacks.onError?.(err);
    console.log(
      `Websocket ${i18nt('ljcw')}=========================`,
      JSON.stringify(err),
    );
  }

  socketOnClose() {
    // this.keepAlive = false;
    this.callbacks.onCloseCallback?.();
  }
}

export default SocketLink;






